import axios from "axios";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ReactQueryKey } from "../../types";

export interface IResponseAttachmentType {
    attachmentType: string,
    mandatory: boolean
}

export const getAttachmentType = async (idBooking: string): Promise<IResponseAttachmentType[]> => {
    const response = axios.get(`/booking/substitution/${idBooking}/attachment-type`);
    return (await response).data;
};

export const useAttachmentTypeQuery = (idBooking: string | undefined, options?: UseQueryOptions<IResponseAttachmentType[]>) => {
    return useQuery<IResponseAttachmentType[]>(
        [ReactQueryKey.BookingAttachmentType, idBooking],
        () => {
            if (!!idBooking) {
                return getAttachmentType(idBooking);
            }
            return [];
        },
        options
    )
};
